import { useQuery } from '@tanstack/react-query';
import { Family } from './useFamily';

export const useFamilies = (filters: { advisorUserId?: string } = {}) => {
  const params: Record<string, unknown> = {};
  if (filters.advisorUserId) params.advisorUserId = filters.advisorUserId;

  const { data, isLoading, isError, refetch } = useQuery<Family[]>({
    queryKey: ['families', params],
  });

  return {
    families: data ?? [],
    isLoading,
    isError,
    refetch,
  };
};
